const _chooseCategoryType = () => {
	const $typesSelect = document.querySelectorAll('[data-type-code]');
	const $section = document.querySelector('[data-choose-state]');
	const $categoryElements = document.querySelectorAll('[data-category]');
	const headerHeight = document.querySelector('header')?.clientHeight || 0;

	$typesSelect.forEach(($el) => $el.addEventListener('click', (event) => {
		const $target = event.currentTarget as HTMLElement;
	
		event.preventDefault;
	
		if ($target.classList.contains('_active')) {
			return;
		}
	
		$target.parentNode?.querySelectorAll('[data-type-code]')?.forEach(($_el) => $_el.classList.remove('_active'));
		$target.classList.add('_active');
	
		$section?.setAttribute('data-choose-state', $target.dataset.typeCode ?? 'none');
	
		$categoryElements.forEach(($el) => {
			if (!$el.checkVisibility({visibilityProperty: true})) return;
			
			if ($el.getAttribute('data-category') === $target.getAttribute('data-type-code')) {
				const elementPosition = $el.getBoundingClientRect().top;
				const offsetPosition = elementPosition + window.scrollY - headerHeight;
			
				window.scrollTo({
					top: window.innerWidth >= 768 ? offsetPosition : offsetPosition - 60,
					behavior: 'smooth'
				});
			}
		});
	}));
};

_chooseCategoryType();